// /v1/search — ticker / name / address autocomplete. Note that the
// backend COALESCEs ticker and name to '' when metadata hasn't resolved
// yet; treat empty strings as "fall back to address" at the call site.
//
// The backend owns ranking, scoping, and dedup: `sort` re-ranks the whole
// match set server-side (relevance = exact symbol/name first, then TON
// liquidity) and `sources` scopes to the selected platforms (default = all
// registered tokens, including still-bonding launches). The UI passes both so a sort/pill change is a real
// re-query, not a client-side reshuffle of one page.

import { apiFetch } from './client'
import type { ListEnvelope, SearchHit } from './types'

export type SortParam = 'relevance' | 'liquidity' | 'volume' | 'change' | 'age'

export interface SearchOptions {
  limit?: number
  sort?: SortParam
  /** Comma-separated platform keys (launchpad brand or DEX family). */
  sources?: string
}

export function search(
  q: string,
  { limit = 20, sort = 'relevance', sources = '' }: SearchOptions = {},
  opts?: RequestInit
): Promise<ListEnvelope<SearchHit>> {
  const params = new URLSearchParams({ q, limit: String(limit) })
  if (sort !== 'relevance') params.set('sort', sort)
  if (sources) params.set('sources', sources)
  return apiFetch(`/v1/search?${params.toString()}`, opts)
}
